module.exports = __webpack_public_path__ + "img/solution-data-logo2.e7ce8d08.png";